import { register } from '@wm/components';

export const registerProps = () => {
    register(
        'wm-network-info-toaster',
        new Map(
            []
        )
    );
};
